import {
  ShareSheetActionTypes,
  ShareSheetActions,
} from '®shared/list-item/share-sheet/share-sheet.actions';
import { ShareSheetState } from '®shared/list-item/share-sheet/share-sheet.state';

export function shareSheetReducer(
  state: ShareSheetState,
  action: ShareSheetActions,
): ShareSheetState {
  switch (action.type) {
    case ShareSheetActionTypes.SHOW_SHARE_SHEET_MODAL: {
      return {
        ...state,
        currentItem: action.payload.item,
        resourceImage: action.payload.resourceImage,
      };
    }

    case ShareSheetActionTypes.HIDE_SHARE_SHEET_MODAL: {
      return {
        ...state,
        currentItem: null,
        resourceImage: null,
      };
    }

    default: {
      return state;
    }
  }
}
